"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
/**
 * Debounce a given callback for a specified period of time.
 * @param callback - Callback function to execute after wait time.
 * @param wait - Debounce wait time in ms.
 */
function debounce(callback, wait = 100) {
    let h;
    const callable = (...args) => {
        clearTimeout(h);
        h = setTimeout(() => callback(...args), wait);
    };
    return callable;
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map